import { useEffect, useState } from 'react';
import getRooms from '../../services/getRooms';
import { Button, Heading, Text } from '@chakra-ui/react';
import Room from '../Reservaciones/Room';
import getOffer from '../../services/getOffers';
import { Loading } from '../Common/Loading';
import { filterRooms } from '../../helpers/transformCabana';
import Offers from '../Reservaciones/Offers';
import { useTranslation } from 'react-i18next';

export const ReservarExterno = ({
  user,
  enabled,
  dia,
  rooms,
  setRooms,
  setPasos,
  pasos,
  setSelectedOffer,
  selectedRoom,
  setSelectedRoom,
  bookingData,
  setBookingData,
}) => {

  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);
    setOffers([]);
    setRooms(null);
    if (dia.startStr && dia.endStr) {
      getRooms(dia.startStr, dia.endStr)
        .then((res) => {
          if (res.status === 200) {
            if (!res.data.rooms.length) {
              setRooms(null);
            } else {
              const newRooms = res.data.rooms;
              if (!newRooms.length) {
                setRooms(null);
              } else {
                setRooms(newRooms);
              }
            }
          }
        })
        .catch((err) => console.error(err))
        .finally(() => setIsLoading(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dia]);

  //const diff = diffDates(dia.start, dia.end)

  const [offers, setOffers] = useState([]);

  const handleSelectedRoom = (room) => {
    setSelectedRoom(room);
    setPasos(3);
  };

  const handleSelectedOffer = (offer) => {
    setSelectedOffer(offer);
    setPasos(4);
    setBookingData({
      ...bookingData,
      date_from: dia.startStr,
      date_to: dia.endStr,
      rooms: [
        {
          room_code: selectedRoom.short_code,
          offer: null,
          rate_category: offer.rate_category,
        },
      ],
      customer: {
        email: user.correo,
        first_name: user.nombre,
        last_name: user.apellidos || '',
        phone_number: user.numeroTel || '1122334455',
        address: user.direccion || 'Address',
        city: user.ciudad || 'Mexico',
        postal_code: user.cp || '03000',
        country: user.pais || 'MX',
      },
    });
  };

  // obtener ofertas
  useEffect(() => {
    if (pasos === 3) {
      setIsLoading(true);
      getOffer(dia.startStr, dia.endStr, selectedRoom.short_code)
        .then((res) => {
          if (res.status === 200) {
            const filteredOffer = res.data.offers.filter((offer) => {
              return offer.title === 'Tarifa base';
            });
            setOffers(filteredOffer);
          }
        })
        .catch((err) => console.log(err))
        .finally(() => setIsLoading(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pasos]);

  if (!enabled) return <div />;

  if (isLoading) return <Loading />;

  if (!isLoading && !rooms)
    return (
      <div className="px-5 py-4 d-flex flex-column">
        <Text fontSize="lg">{t('NO_ROOMS_AVAILABLE')}</Text>
        <Button
          width="xs"
          my="5"
          colorScheme="blue"
          onClick={() => setPasos(1)}
        >
          {t('GO_BACK_TO_CALENDAR')}
        </Button>
      </div>
    );

  return (
    <div
      className="px-5 py-2"
      style={{ minHeight: '50vh' }}
    >
      {pasos === 2 && (
        <>
          <Heading my={2}>{t('RESERVE')}</Heading>
          <div className="d-flex justify-content-between pb-4">
            <div>
              <div>
                <span className="fw-bold">{t('ENTRY_DATE')}</span> 
                {dia.startStr}
              </div>
              <div>
                <span className="fw-bold">{t('EXIT_DATE')}</span>
                {dia.endStr}
              </div>
            </div>
          </div>
          <Heading
            my={2}
            size={'md'}
          >
            <Heading my={2} size={'md'}>{t('AVAILABLE_ROOMS')}</Heading>
          </Heading>
          <div
            className=""
            style={{
              overflowY: 'scroll',
              display: 'grid',
              gridTemplateColumns: 'repeat(3,1fr)',
              gap: '25px',
            }}
          >
            {rooms.map((room) => (
              <Room
                key={room.short_code}
                room={room}
                onClick={handleSelectedRoom}
              />
            ))}
          </div>
        </>
      )}
      {pasos === 3 && !isLoading && (
        <>
          <Heading my={2}>{t('AVAILABLE_OFFERS')}</Heading>
          <div
            className="my-2"
            style={{
              maxHeight: '75vh',
              overflowY: 'scroll',
              display: 'grid',
              gridTemplateColumns: 'repeat(3,1fr)',
              gap: '25px',
            }}
          >
            {offers.map((offer) => (
              <Offers
                key={offer.rate_category}
                offer={offer}
                onClick={handleSelectedOffer}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
};
